import { render, staticRenderFns } from "./SeoTagsImageBlock.vue?vue&type=template&id=86e0cdf8&scoped=true&"
import script from "./SeoTagsImageBlock.vue?vue&type=script&lang=js&"
export * from "./SeoTagsImageBlock.vue?vue&type=script&lang=js&"
import style0 from "./SeoTagsImageBlock.vue?vue&type=style&index=0&id=86e0cdf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e0cdf8",
  null
  
)

export default component.exports